export const mapserviceList = [
  {
    roles: ["customer"],
    layerId: ["5f28cd1f8c2aadf82070187e", "5f2cd46df90cc547c1c46427"],
  },
  {
    roles: ["root", "admin", "officer_head", "officer"],
    layerId: [
      "5ec4d27c8c861c736024026f",
      "5f2cd46df90cc547c1c46427",
      "5ef9b64bb8f9cda995efc162",
      "5ef9b603b8f9cda995efc161",
      "5ef9b50fb8f9cda995efc15f",
      "5ef9b5d3b8f9cda995efc160",
    ],
  },
];

export const categoryLayers = {
  //   landbase: [
  //     "LandmarkPoint",
  //     "DistrictPoly",
  //     "Landmarkline",
  //     "Centerline",
  //     "RoadEdge",
  //     "Building",
  //     "BuildingLine",
  //     "Hydrology",
  //     "LandmarkPoly",
  //   ],
  overhead: {
    groupX: [
      { check: true, key: "Lowvoltagemeter" },
      { check: false, key: "HighTensionMeter" },
      { check: false, key: "GroupMeter" },
      { check: true, key: "Transformer" },
      { check: false, key: "Switch" },
      { check: true, key: "Fuse" },
      { check: true, key: "Capacitor" },
      { check: true, key: "LightningArrestor" },
      { check: false, key: "InlineEquipment" },
      { check: true, key: "Ground" },
      { check: true, key: "SpanGuy" },
      { check: true, key: "CircuitBreaker" },
      { check: true, key: "Pole" },
      { check: true, key: "MeterLine" },
      { check: false, key: "Meter_Link" },
      { check: false, key: "OHHVConductor" },
      { check: true, key: "OHMVConductor" },
      { check: true, key: "OHLVConductor" },
      { check: false, key: "OHLVConductorUnderBuilding" },
    ],
    groupA: [
      { check: false, key: "OHSLConductor" },
      { check: false, key: "Streetlight" },
      { check: false, key: "StreetlightControl" },
      { check: false, key: "SLInlineEquipment" },
      { check: false, key: "UGSLConductor" },
      { check: false, key: "SLInlineEquipment" },
    ],
    groupZ: [
      { check: false, key: "Splice" },
      { check: false, key: "FiberOpticCable" },
      { check: false, key: "FiberOpticCable_MEA" },
    ],
  },
  underground: {
    groupY: [
      { check: false, key: "ManHole" },
      { check: false, key: "UGHVConductor" },
      { check: false, key: "UGMVConductor" },
      { check: false, key: "UGLVConductor" },
      { check: false, key: "DuctBank" },
    ],
  },
};

export const administLayers = [
  { check: false, key: "province" },
  { check: false, key: "amphoe" },
  { check: false, key: "tambon" },
  { check: false, key: "municipal" },
  { check: false, key: "housing" },
];
